import { SFConstants } from "../../../constants/SFConstants";
import { Poker2Command } from "../Poker2Command";

export class CJFCommand extends Poker2Command {
    protected get cmdId(): string {
        return "cjf";
    }

    public executeCommand(error: number, params: any[]): boolean {
        return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
